import { LocationType } from '@indeed/location-common-datatypes';
export class LocationTypeAdapter {
    static fromGraphQL(type) {
        switch (type) {
            case 'COUNTRY':
                return LocationType.COUNTRY;
            case 'ADMIN1':
                return LocationType.ADMIN1;
            case 'ADMIN2':
                return LocationType.ADMIN2;
            case 'ADMIN3':
                return LocationType.ADMIN3;
            case 'ADMIN4':
                return LocationType.ADMIN4;
            case 'CITY':
                return LocationType.CITY;
            case 'POSTAL_CODE':
                return LocationType.POSTAL_CODE;
            case 'STATION':
                return LocationType.STATION;
            case 'AIRPORT':
                return LocationType.AIRPORT;
            case 'WATER':
                return LocationType.WATER;
            case 'POSTAL_PLACE':
                return LocationType.POSTAL_PLACE;
            case 'MISC':
                return LocationType.MISC;
            case 'PRECISE_LOCATION':
                return LocationType.PRECISE_LOCATION;
        }
    }
    static toGraphQL(type) {
        switch (type) {
            case LocationType.COUNTRY:
                return 'COUNTRY';
            case LocationType.ADMIN1:
                return 'ADMIN1';
            case LocationType.ADMIN2:
                return 'ADMIN2';
            case LocationType.ADMIN3:
                return 'ADMIN3';
            case LocationType.ADMIN4:
                return 'ADMIN4';
            case LocationType.CITY:
                return 'CITY';
            case LocationType.POSTAL_CODE:
                return 'POSTAL_CODE';
            case LocationType.STATION:
                return 'STATION';
            case LocationType.AIRPORT:
                return 'AIRPORT';
            case LocationType.WATER:
                return 'WATER';
            case LocationType.POSTAL_PLACE:
                return 'POSTAL_PLACE';
            case LocationType.MISC:
                return 'MISC';
            case LocationType.PRECISE_LOCATION:
                return 'PRECISE_LOCATION';
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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